import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-213a3fc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "popover-content",
  class: "d-none"
}
const _hoisted_2 = { class: "row g-0" }
const _hoisted_3 = { class: "col-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "filter-header fs-5 fw-bold mb-5" }, " Days ", -1))
const _hoisted_5 = ["data-day"]
const _hoisted_6 = { class: "col-7 pe-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "filter-header fs-5 fw-bold mb-5" }, " Times ", -1))
const _hoisted_8 = ["data-time"]

import { onMounted, PropType } from 'vue'
import BsCheckbox from '@/components/BsCheckbox/BsCheckbox.vue'
import { Popover } from 'bootstrap/dist/js/bootstrap'
import { MicroFilter, filterWeekDays, filterTimes } from './SessionSeach.interfaces'


export default /*#__PURE__*/_defineComponent({
  __name: 'MicroFilterPopover',
  props: {
  microFilter: {
    type: Object as PropType<MicroFilter>,
    default: () => {}
  }
},
  emits: ['update:micro-filter'],
  setup(__props, { emit: __emit }) {

const props = __props

onMounted(() => {
  const popoverButton = document.getElementById('microfilter')!
  const popover = new Popover(popoverButton, {
    container: '#search-section',
    content: document.getElementById('popover-content')!.innerHTML.replaceAll('BsCheckbox_', 'PopoverBsCheckbox_'),
    html: true,
    sanitize: false
  })

  document.addEventListener('click', () => { popover?.hide() })

  popoverButton?.addEventListener('shown.bs.popover', () => {
    popoverButton.classList.add('active')

    const selectedDayLabels = props?.microFilter?.days?.map(day => day.label) ?? []
    const selectedTimeLabels = props?.microFilter?.times?.map(time => time.label) ?? []
    document
      .querySelectorAll('#__classrooms-student-mfe #search-section .popover-body input[type=checkbox]')
      .forEach((elem) => {
        elem.addEventListener('change', microfilterChanged)

        const label = elem.parentElement?.nextElementSibling?.firstChild?.innerHTML.trim()
        if (label && (selectedDayLabels.includes(label) || selectedTimeLabels.includes(label))) {
          (elem as HTMLInputElement).checked = true
        }
      })
    document
      .querySelector('#__classrooms-student-mfe #search-section .popover')
      ?.addEventListener('click', (e: Event) => { e.stopPropagation() })
  })
  popoverButton?.addEventListener('hidden.bs.popover', () => {
    popoverButton.classList.remove('active')
  })
})

const emit = __emit

const microfilterChanged = (e: Event) => {
  e.stopPropagation()

  const microfilter: MicroFilter = { days: [], times: [], tags: [] }
  document
    .querySelectorAll('.popover-body input[type=checkbox]:checked')!
    .forEach((elem) => {
      const day = elem?.parentElement?.parentElement?.parentElement?.dataset['day']
      const time = elem?.parentElement?.parentElement?.parentElement?.dataset['time']

      if (day) {
        microfilter.days.push(JSON.parse(day))
      } 
      if (time) {
        microfilter.times.push(JSON.parse(time))
      }
    })
  emit('update:micro-filter', microfilter)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      id: "microfilter",
      class: "btn",
      "data-bs-toggle": "popover",
      "data-bs-placement": "bottom",
      "aria-label": "open micro filter menu",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterWeekDays), (day) => {
            return (_openBlock(), _createElementBlock("div", {
              key: day.value,
              "data-day": JSON.stringify(day),
              class: "mt-2"
            }, [
              _createVNode(BsCheckbox, {
                label: day.label
              }, null, 8, ["label"])
            ], 8, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterTimes), (time) => {
            return (_openBlock(), _createElementBlock("div", {
              key: time.value,
              "data-time": JSON.stringify(time),
              class: "mt-2"
            }, [
              _createVNode(BsCheckbox, {
                label: time.label
              }, null, 8, ["label"])
            ], 8, _hoisted_8))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})